<template lang="">
    <Layout>
       
    <iframe 
        class="taxonomy-map"
        width="100%" 
        title="Mapa interactivo de taxonomía VITA"
        style="border: 1px solid #d0d0d0;border-radius: 6px;"
        src="https://www.mindomo.com/mindmap/vita-bffb1d7508aa4e169ba3df08d3cab34d" 
        frameborder="0" 
        allowfullscreen>
        Your browser does not support frames. 
        <a href="https://www.mindomo.com/mindmap/vita-bffb1d7508aa4e169ba3df08d3cab34d" target="_blank">View</a> 
        this map on its original site. It was created using 
        <a href="https://www.mindomo.com" target="_blank">Mindomo</a>.
    </iframe>

    </Layout>
</template>
<script>
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';

import ClassificationTree from '../Components/Classification/ClassificationTree.vue'
import Layout from '../Components/Shared/Layout.vue'

export default {
    components: { Layout, ClassificationTree, VueImageZoomer },
    props: ["classificationConfig"],
    setup(props) {

        const taxTypes = [
            { id: 'VITA', name: 'VITA' },
            { id: 'DOMINIO', name: 'DOMINIO' },
            { id: 'REINO', name: 'REINO' },
            { id: 'DIVISIÓN', name: 'DIVISIÓN' },
            { id: 'CLASE', name: 'CLASE' },
            { id: 'ORDEN', name: 'ORDEN' },
            { id: 'FAMILIA', name: 'FAMILIA' },
            { id: 'GENERO', name: 'GENERO' },
            { id: 'ESPECIE', name: 'ESPECIE' }
        ]

        return {
            taxTypes
        }
    }
}
</script>
<style lang="scss">
#image-zoomer {
    img.vh--image {
        max-width: initial !important;
    }
}

.taxonomy-map {
    display: block;
    width: 100% !important;
    height: max(30rem, calc(100vh - 21rem)) !important;
    min-height: 30rem;
}

@media (min-width: 641px) and (max-width: 1024px) {
    .taxonomy-map {
        height: max(32rem, calc(100vh - 20rem)) !important;
        min-height: 32rem;
    }
}

@media (max-width: 640px) {
    .taxonomy-map {
        height: max(36rem, 72vh) !important;
        min-height: 36rem;
    }
}

.classification {
    border: solid 2px rgba(63, 63, 63, 0.2);
    padding: 5px 15px;
    border-radius: 50px;
    min-width: 150px;
    text-align: center;
    margin: 2px 5px;
    font-size: 12px;

    &.VITA {
        background-color: #C65EEB;
    }

    &.DOMINIO {
        background-color: #77C3FF;
    }

    &.REINO {
        background-color: #77FFF9;
    }

    &.DIVISIÓN {
        background-color: #77FFB6;
    }

    &.CLASE {
        background-color: #7BFF77;
    }

    &.ORDEN {
        background-color: #BEFF77;
    }

    &.FAMILIA {
        background-color: #FFFD77;
    }

    &.GENERO {
        background-color: #FFBA77;
    }

    &.ESPECIE {
        background-color: #EBAE85;
    }

    &:hover {
        transform: scale(1.1);
    }
}
</style>
